<template>
  <b-modal
    v-model="isOpen"
    title="Feedback Modal"
    size="xl"
    @close="closeModal()"
  >
    <div class="service_replace_modal">
      <div style="min-height: 25vh">
        <div class="text-center mb-5">
          <strong>FEEDBACK</strong>
        </div>
        <b-field label="Topic*:" class="header_select" style="width: 100%">
          <Multiselect
            v-model="form.topic"
            :options="options"
            :taggable="true"
            class="mb-5"
            tag-position="top"
            :max-height="200"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            :allow-empty="true"
            placeholder="Select or add your topic"
            @tag="addTag"
          >
          </Multiselect>
        </b-field>
        <b-field label="Priority*:" class="header_select w-100">
          <multiselect
            v-model="priority"
            label="title"
            track-by="title"
            :options="priorities"
            :option-height="104"
            :show-labels="false"
          >
            <template #singleLabel="{ option }">
              <div class="custom-priority-item">
                <div :style="{ background: option.color }" />
                <span>{{ option.title }}</span>
              </div>
            </template>
            <template #option="{ option }">
              <div class="custom-priority-item">
                <div :style="{ background: option.color }" />
                <span>{{ option.title }}</span>
              </div>
            </template>
          </multiselect>
        </b-field>
        <BaseTextarea
          v-model="form.description"
          size="large"
          label="Description:"
          class="mb-4"
          :maxlength="500"
          placeholder="Tell us more about your Feedback"
        />
        <div style="font-size: 12px">
          We are attaching the print screen from where start your feedback.
        </div>
      </div>
      <div class="is-flex is-justify-content-flex-end">
        <BaseButton
          size="small"
          :loading="loading"
          :disabled="disabled"
          @click="send"
        >
          <div slot="text">Send</div>
        </BaseButton>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";
import BaseSelect from "@/components/base-ui/BaseSelect.vue";
import BaseButton from "@/components/base-ui/BaseButton.vue";
import IconCheck from "@/components/icons/IconCheck.vue";
import html2canvas from "html2canvas";
import userService from "@/services/users";
import { openToast } from "@/utils/utils";
import { mapGetters } from "vuex";

export default {
  name: "FeedbackModal",
  components: {
    IconCheck,
    BaseButton,
    BaseSelect,
    Multiselect,
  },
  props: {
    isModalOpen: {
      type: Boolean,
      default: false,
    },
    closeModal: {
      type: Function,
      default: () => {},
    },
    service: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    const priorities = [
      { title: "LOW", color: "#0000ff" },
      { title: "MEDIUM", color: "#ff6f0c" },
      { title: "HIGH", color: "#ff0000" },
    ];

    return {
      priorities: priorities,
      priority: priorities[1],
      options: [
        "I do not understand",
        "Price Error",
        "Cost Error",
        "Content Error (Image, Video, Description or Notes)",
        "VIPER Error",
      ],
      newTags: [],
      loading: false,
      isOpen: false,
      form: this.getDefaultForm(),
    };
  },
  watch: {
    isModalOpen(newValue) {
      this.isOpen = newValue;
      if (newValue) {
        this.clearForm();
        this.form.itinerary = this.itinerary.data.id;
        this.form.itinerary_service = this.service?.id ?? null;
        this.capture();
      }
    },
  },
  computed: {
    ...mapGetters({
      itinerary: "itinerary/getItinerary",
    }),
    disabled() {
      return !this.priority || !this.form.topic || !this.form.image;
    },
  },
  methods: {
    getDefaultForm() {
      return {
        priority: null,
        topic: null,
        description: "",
        image: null,
        itinerary: null,
        itinerary_service: null,
      };
    },
    clearForm() {
      this.form = this.getDefaultForm();
    },
    capture() {
      html2canvas(document.body, { logging: false }).then((canvas) => {
        this.form.image = canvas.toDataURL("image/jpg");
      });
    },
    async send() {
      this.loading = true;
      const payload = {
        ...this.form,
        priority: this.priority.title,
      };
      await userService.sendFeedback(payload);
      this.clearForm();
      this.loading = false;
      this.closeModal();
      openToast(this.$buefy, "Thanks your feedback was sent!", "is-success");
    },
    addTag(newTopic) {
      this.form.topic = newTopic;
      this.options.push(newTopic);
    },
  },
};
</script>
<style>
.service_replace_modal {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  border-radius: 1rem;
  padding: 2rem 2rem 3rem;
  text-align: left;
}
.modal__body__content {
  width: 100%;
}
.service_replace_modal table :is(th, td) {
  font-size: 1rem;
}
.custom-priority-item {
  display: flex;
  align-items: center;
}
.custom-priority-item div {
  width: 12px;
  height: 12px;
  margin-right: 8px;
}
</style>
